import { usePurchaseUploadXmlFile } from '@/core/domain/purchase/Purchase.hooks';
import { Col, Button, Upload } from 'antd';

interface Props {
  hasXml: boolean;
  purchaseId?: number;
}

export default function PurchaseUploadXml(props: Props) {
  const uploadXmlFile = usePurchaseUploadXmlFile();

  if (props.hasXml) return null;

  return (
    <Col>
      <Upload
        accept="application/xml,text/xml"
        beforeUpload={(file) => {
          if (!['text/xml', 'application/xml'].includes(file.type)) {
            return Promise.reject('Tipo do arquivo inválido');
          }
        }}
        showUploadList={false}
        customRequest={async (options) => {
          try {
            if (!props.purchaseId) return;

            options.onProgress?.({ percent: 30 });

            await uploadXmlFile.mutateAsync({
              purchaseId: props.purchaseId,
              file: options.file as File,
            });

            options.onSuccess?.(options.file);
          } catch (error) {
            options.onError?.(
              new Error(String(error) || 'Não foi possível enviar o arquivo'),
            );
          } finally {
            options.onProgress?.({ percent: 100 });
          }
        }}
      >
        <Button loading={uploadXmlFile.isLoading}>
          {uploadXmlFile.isLoading ? 'Vinculando...' : 'Vincular XML'}
        </Button>
      </Upload>
    </Col>
  );
}
